/**
 * @fileOverview This file contains the implementation of the useFetchTemplateAndInputs hook for the ReportViewer component
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region Imports
import { useCallback, useState } from 'react';
import { GlobalVariables } from '../globalVar';
import customAxios from '../utils/customAxios';
import { BLANK_PDF } from '@pdfme/common';
import { getToast } from '../utils/toastConfig';
import { useTranslationHook } from './UseTranslationHook';
//#endregion

const useFetchTemplateAndInputs = () => {
  const [showReportViewer, setShowReportViewer] = useState(false);
  const [reportTemplate, setReportTemplate] = useState(null);
  const [reportInputs, setReportInputs] = useState(null);

  const { builderVAlertS, builderVAlertE } = useTranslationHook();

  const fetchTemplateAndInputs = useCallback(
    async (visitId) => {
      try {
        const response = await customAxios.get(
          `${GlobalVariables.getURL()}reportViewer/${visitId}`,
          {
            headers: {
              Authorization: 'bearer ' + localStorage.getItem('token'),
            },
          }
        );
        const { template, inputs } = response.data;
        const parsedTemplate =
          typeof template === 'string' ? JSON.parse(template) : template;

        // Default case: empty basePdf
        if (!parsedTemplate.basePdf) {
          parsedTemplate.basePdf = BLANK_PDF;
        }

        // Default case: empty schemas
        if (
          !parsedTemplate.schemas ||
          parsedTemplate.schemas.length === 0 ||
          Object.keys(parsedTemplate.schemas[0]).length === 0
        ) {
          parsedTemplate.schemas = [
            {
              P1: {
                type: 'text',
                width: 100,
                height: 10,
                position: {
                  x: 0,
                  y: 0,
                },
                readOnly: true,
                content: 'P1',
              },
            },
          ];
        }

        setReportTemplate(parsedTemplate);
        setReportInputs(inputs.length > 0 ? inputs : [{}]);
        setShowReportViewer(true);
        getToast({
          status: 'success',
          title: builderVAlertS,
        });
      } catch (error) {
        console.error('Error fetching template and inputs:', error);
        getToast({
          status: 'error',
          title: builderVAlertE,
        });
      }
    },
    [reportTemplate, reportInputs]
  );

  const closeReportViewer = () => setShowReportViewer(false);

  return {
    showReportViewer,
    setShowReportViewer,
    reportTemplate,
    reportInputs,
    fetchTemplateAndInputs,
    closeReportViewer,
  };
};

export default useFetchTemplateAndInputs;
